import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import axios from "axios";
import myConfig from "../configs/config";

const PendingMachineRegistrationContext = createContext({
  pendingCount: 0,
  pendingItems: [],
  loading: false,
  error: null,
  refreshPendingRegistrations: () => {},
});

export function usePendingMachineRegistration() {
  return useContext(PendingMachineRegistrationContext);
}

export function PendingMachineRegistrationProvider({ farm_id, children }) {
  const [pendingCount, setPendingCount] = useState(0);
  const [pendingItems, setPendingItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshPendingRegistrations = useCallback(async () => {
    if (!farm_id) return;

    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(
        `${myConfig.API_URL}/equipment/pending_registration_count/?farm_id=${farm_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("client-token")}`,
          },
        }
      );
      const data = res.data || {};
      const items = Array.isArray(data.items) ? data.items : [];
      setPendingItems(items);
      setPendingCount(
        typeof data.count === "number" ? data.count : items.length
      );
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [farm_id]);

  useEffect(() => {
    refreshPendingRegistrations();
    const interval = setInterval(refreshPendingRegistrations, 60000);
    return () => clearInterval(interval);
  }, [refreshPendingRegistrations]);

  return (
    <PendingMachineRegistrationContext.Provider
      value={{
        pendingCount,
        pendingItems,
        loading,
        error,
        refreshPendingRegistrations,
      }}
    >
      {children}
    </PendingMachineRegistrationContext.Provider>
  );
}
